module.exports = __webpack_public_path__ + "static/img/bullet-puzzle.99d1af6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bullet-puzzle.png
// module id = tPwb
// module chunks = 1